// extracted by mini-css-extract-plugin
export default {"f":"_54970725c0","main":"_562cef2b28","btn":"b982403c15","w":"abbe9578dd","h":"_96fb36473c","lh25":"_7134ae6706","wb":"b1e0537eab","b":"_9a6c3f5c0b","bx":"c69ed01b86"};